'use client';

import { usePathHistory } from '@/hooks/use-path-history';

/**
 * 路径历史记录效果组件
 * 
 * 职责：
 * - 应用路径历史记录的副作用
 * - 自动记录用户访问的路径
 * 
 * 记录方式：
 * - paths: 去重记录（最多6条）
 * - allPaths: 完整记录，包括重复路径（最多6条）
 * 
 * 特点：
 * - 无 UI 渲染（返回 null）
 * - 纯副作用组件
 * - 在 SharedLayout 中全局使用
 */
export default function PathHistoryEffects() {
  usePathHistory();
  return null;
}

